import { __spreadArrays } from "tslib";
import { Util } from '@antv/g2';
var ORIGIN_MATRIX = [1, 0, 0, 0, 1, 0, 0, 0, 1];
/**
 * 对元素设置一些操作（旋转、移动等），每次重置 matrix
 * @param group
 * @param actions
 */
export function groupTransform(group, actions) {
    var ulMatrix = __spreadArrays(ORIGIN_MATRIX);
    var matrix = Util.transform(ulMatrix, actions);
    group.setMatrix(matrix);
}
/**
 * 矩阵变换
 * @param actions
 * @param matrix
 */
export function transform(actions, matrix) {
    var ulMatrix = matrix ? __spreadArrays(matrix) : __spreadArrays(ORIGIN_MATRIX);
    return Util.transform(ulMatrix, actions);
}
//# sourceMappingURL=g-util.js.map